import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { IFilter, IOptionsItem } from '../../components/FilterContainer';
import { ISelectedFilterItem } from '../../components/MiniFilterList';
import { IFile } from '../../services/api/requests/getAudioList';

const selectEntities = (state: RootState) => state.entities;

export const selectData = createSelector(
  selectEntities,
  (state) => state.allData,
);
export const selectFiles = createSelector(
  selectData,
  (state) => state.results.files,
);

export const selectFilters = createSelector(
  selectData,
  (state) => state.results.filters,
);

export const selectIsPlaying = createSelector(selectFiles, (state) => {
  return state?.some((item: IFile) => item.isPlaying);
});

export const selectCategoryFilters = createSelector(selectFilters, (state) => {
  const filterItems = [
    'categories',
    'quotes__scripture',
    'quotes__book',
    'quotes__chapter',
  ];
  return state?.filter((item: any) => filterItems.includes(item.name));
});

export const selectDateFilters = createSelector(selectFilters, (state) => {
  const filterItems = ['date__year', 'date__month'];
  return state?.filter((item: any) => filterItems.includes(item.name));
});

export const selectLocationFilters = createSelector(selectFilters, (state) => {
  const filterItems = ['country', 'locality'];
  return state?.filter((item: any) => filterItems.includes(item.name));
});

export const selectSelectedFilters = createSelector(selectFilters, (state) => {
  return state?.reduce((acc: Array<ISelectedFilterItem>, item: any) => {
    let filterItem = {
      name: item.name,
      title: item.title,
      value: '',
      text: '',
    };

    const selectedItems = item.options?.filter(
      (option: IOptionsItem) => !!option.selected,
    );
    const isSelected = !!selectedItems?.length;
    if (isSelected) {
      filterItem = {
        ...filterItem,
        value: selectedItems?.[0]?.value,
        text: selectedItems?.[0]?.text,
      };

      acc.push(filterItem);
    }

    return acc;
  }, []);
});

export const selectPaginationInfo = createSelector(selectEntities, (state) => {
  const { count, next, previous } = state.allData;
  return { count: Math.ceil(count / 6), next, previous };
});

export const selectExistParams = createSelector(selectFilters, (state) => {
  return state.reduce((accum: any, current: IFilter) => {
    const selected = current.options.find((f) => f.selected);
    if (selected) {
      accum = {
        ...accum,
        [current.name]: selected.value,
      };
    }
    return accum;
  }, {});
});
